(() => {


if (window) {
    //Define selectors
    const header = document.querySelector("header");
    const nav = document.querySelector("#nav");
    const navToggle = document.querySelector("#nav-toggle");
    const navInner = document.querySelector("#nav-inner");
    const subMenuClose = document.querySelectorAll(".nav__submenu-close");
    const isDesktop = window.innerWidth > 1024;
    const subLinks = document.querySelectorAll(".nav__link--sublink");
    const directLinks = document.querySelectorAll(".nav__link--direct");
    if (header && nav) {
        //Toggle Nav
        const toggleNav = ()=>{
            header.classList.toggle("nav-open");
            navInner.classList.toggle("nav__inner--open");
            navToggle.classList.toggle("nav__toggle--active");
            closeSubmenu();
        };
        //Click on Burger Menu
        if (navToggle) navToggle.addEventListener("click", ()=>{
            toggleNav();
        });
        const closeSubmenu = async ()=>{
            nav.querySelectorAll(".nav__submenu--open").forEach((openSubnav)=>{
                openSubnav.classList.remove("nav__submenu--open");
            });
        };
        const checkActiveLink = (link)=>{
            if (link.href === window.location.href) {
                link.classList.add("nav__item--active");
                link.closest(".nav__item--level-1").classList.add("nav__item--active");
            }
        };
        const clickOutside = (e)=>{
            if (nav?.contains(e.target)) ;
            else {
                toggleNav();
                document.removeEventListener("click", clickOutside);
            }
        };
        //Handle direct Links
        directLinks.forEach((link)=>{
            link.addEventListener("click", ()=>{
                toggleNav();
            });
            //set active class
            checkActiveLink(link);
        });
        //Handle Sublinks
        subLinks.forEach((link)=>{
            //Click on sublink
            link.addEventListener("click", (e)=>{
                //Close open submenus on desktop if open
                if (isDesktop) closeSubmenu();
                //open submenu from clicked element
                if (link && link.parentElement) // @ts-ignore
                link.parentElement.querySelector(".nav__submenu").classList.toggle("nav__submenu--open");
                //Click outside directive
                setTimeout(()=>{
                    document.addEventListener("click", clickOutside);
                }, 500);
            });
        });
        //Handle close submenu
        subMenuClose.forEach((close)=>{
            // Click on close button
            close.addEventListener("click", ()=>{
                if (isDesktop) closeSubmenu();
                else if (close && close.parentElement) close.parentElement.classList.remove("nav__submenu--open");
            });
        });
    }
}


const $0c5b6944dc9594db$var$modals = document.querySelectorAll("[data-modal]");
$0c5b6944dc9594db$var$modals.forEach((modal)=>{
    modal.addEventListener("click", ()=>{
        console.dir(modal.attributes["data-modal"].value);
        const target = document.querySelector(`#${modal.attributes["data-modal"].value}`);
        target.classList.add("active");
        const close = target.querySelectorAll("[data-modal-close]");
        close.forEach((item)=>{
            item.addEventListener("click", ()=>{
                target.classList.remove("active");
            });
        });
    });
});


const $1602c4ca4bfbc2da$var$slider = document.querySelectorAll(".slider");
$1602c4ca4bfbc2da$var$slider?.forEach((slider)=>{
    const sliderWrapper = slider.querySelector(".slider__wrapper");
    const sliderContainer = slider.querySelector(".slider__container");
    const sliderNav = slider.querySelector(".slider__nav");
    let slidePrev;
    let slideNext;
    const itemWidth = sliderContainer?.querySelector(".slider__item")?.offsetWidth;
    if (sliderNav) {
        slidePrev = sliderNav.querySelector(".slider__prev");
        slideNext = sliderNav.querySelector(".slider__next");
    }
    const watchNavState = ()=>{
        if (sliderContainer.scrollLeft === 0) slidePrev.classList.remove("active");
        else slidePrev.classList.add("active");
        if (sliderContainer.scrollLeft + sliderWrapper.offsetWidth >= sliderContainer.scrollWidth) slideNext.classList.remove("active");
        else slideNext.classList.add("active");
    };
    watchNavState();
    if (slideNext) slideNext.addEventListener("click", ()=>{
        watchNavState();
        if (sliderContainer.scrollLeft + sliderWrapper.offsetWidth < sliderContainer.scrollWidth) sliderContainer.scrollLeft += itemWidth * 1.5;
    });
    if (slidePrev) slidePrev.addEventListener("click", ()=>{
        watchNavState();
        if (sliderContainer.scrollLeft - sliderWrapper.offsetWidth < sliderContainer.scrollWidth) sliderContainer.scrollLeft -= itemWidth * 1.5;
    });
}); //HTML STRUCTURE
 /* <div class="slider">
  <div class="slider__wrapper">
    <div class="slider__container">
      <div class="slider__item">
        ...ITEM
        </div>
      <div class="slider__item">
        ...ITEM
        </div>
      <div class="slider__item">
        ...ITEM
        </div>
    </div>
  </div>
  <div class="slider__nav">
    <div class="slider__prev">
      <div class="icon-arrow-left"></div>
    </div>
    <div class="slider__next">
      <div class="icon-arrow-right"></div>
    </div>
  </div>
</div> */ 


const $190904a98866f3c6$var$videos = document.querySelectorAll(".gallery__play");
if ($190904a98866f3c6$var$videos) $190904a98866f3c6$var$videos.forEach((video)=>{
    video.addEventListener("click", ()=>{
        const targetVideo = document.getElementById(video.dataset.video);
        targetVideo.play();
        targetVideo.controls = true;
        video.style.display = "none";
    });
});


//--------------------Intersection observer
const $d6f5850eb24362c8$var$animateTarget = document.querySelectorAll(".animate-observe");
const $d6f5850eb24362c8$var$options = {};
const $d6f5850eb24362c8$var$animateTargetObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) entry.target.classList.add("animate--reveal");
    });
}, $d6f5850eb24362c8$var$options);
$d6f5850eb24362c8$var$animateTarget.forEach(function(animateTarget) {
    $d6f5850eb24362c8$var$animateTargetObserver.observe(animateTarget);
});






})();
//# sourceMappingURL=main.js.map
